export const getplaceHolder = (schema) => {
    if (schema.placeHolder) {
        return schema.placeHolder;
    }
    let str = "";
    switch (schema.component) {
        case "ElInput":
        case "ElInputNumber":
            str = "请输入";
            break;
        case "ElSelect":
        case "ElTimePicker":
        case "ElDatePicker":
        case "ElCascader":
            str = "请选择";
            break;
    }

    return str + schema.label;
}

export const getOptionsLabel = (schema, row) => {
    const key = schema.componentProps?.props?.label ?? 'label'
    return row[key]
}
export const getOptionsValue = (schema, row) => {
    const key = schema.componentProps?.props?.value ?? 'value'
    return row[key]
}



// WEBPACK FOOTER //
// ./src/components/easyForm/utils.js